import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { EVENTS_CUSTOM_FIELDS_KEY } from './useEventCustomFieldDefinitions';

function deleteEventCustomField({
  schoolyearId,
  schoolId,
  id,
}: {
  schoolyearId: string;
  schoolId: string;
  id: string;
}) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/events-custom-fields/${id}`,
    {
      method: 'DELETE',
    },
  );
}

export const useDeleteEventCustomFieldDefinition = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      deleteEventCustomField({ schoolyearId, schoolId, id }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EVENTS_CUSTOM_FIELDS_KEY, schoolyearId, schoolId],
      });
    },
  });
};
